/** Canonical navigation paths retain one slash and leave file requests alone. */
export function canonicalPathname(pathname: string): string {
  const normalized = pathname.replace(/\/{2,}/g, '/');
  if (normalized === '/' || /\.[a-zA-Z0-9]+$/.test(normalized)) return normalized;
  return `${normalized.replace(/\/+$/, '')}/`;
}